import React from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import StringInput from '../../../../components/inputs/StringInput'
import { InvoiceExtensionFormFields } from '../InvoiceExtensionPage'

interface AdditionalDetailsStepProps {
	form: UseFormReturn<InvoiceExtensionFormFields>
}

const AdditionalDetailsStep: React.FC<AdditionalDetailsStepProps> = ({ form }) => {
	const { t: tc } = useTranslation('pages_invoiceExtension')

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
			<div className='text-text-dark dark:text-white text-xs'>
				{tc('additionalDetails.description')}
			</div>

			<Controller
				control={form.control}
				name={'additionalDetails'}
				defaultValue=''
				render={({ field }) => (
					<StringInput
						value={field.value}
						onChange={field.onChange}
						multiline
						multilineRows={4}
						label={tc('additionalDetails.additionalDetails')}
					/>
				)}
			/>
		</div>
	)
}

export default AdditionalDetailsStep
